<template>
    <div class="reg-select">
        <h3 style="text-align: left">Your Order</h3>
        <div class="table-responsive">
            <table class="table">
                <thead>
                <tr>
                    <th style="text-align: left" scope="col">Item</th>
                    <th style="text-align: right" scope="col">Price</th>
                </tr>
                </thead>
                <transition name="component-fade" mode="out-in">
                    <tbody v-if="showCheckout === true">
                    <tr v-if="state.registrantData.regType.id">
                        <td style="text-align: left" scope="col">{{state.registrantData.regType.name}} - {{state.registrantData.regType.type}}</td>
                        <td style="text-align: right" scope="col">${{state.registrantData.regType.price}}
                        </td>
                    </tr>
                    <tr v-if="state.registrantData.btlWorkshop">
                        <td style="text-align: left" scope="col" v-html="state.meetingData.btl_workshop.name + ' - Event RSVP'"></td>
                        <td style="text-align: right" scope="col">${{state.meetingData.btl_workshop.price}}
                        </td>
                    </tr>
                    <tr style="color:cadetblue" v-if="state.registrantData.promoData.clear === 'pass' && showPromo">
                        <td style="text-align: left" scope="col" >Promo: <em>{{state.registrantData.promoCode}}</em></td>
                        <td style="text-align: right" v-if="state.registrantData.promoData.type === 'percentage'" scope="col">(-{{state.registrantData.promoData.referdiscount}}%)
                        <td style="text-align: right" v-else scope="col">(${{state.registrantData.promoData.referdiscount}})
                        </td>
                    </tr>
                    <tr>
                        <th style="text-align: left" scope="col">Total:</th>
                        <th style="text-align: right" scope="col"><h3>${{state.registrantData.total}}</h3></th>
                    </tr>
                    </tbody>

                </transition>
            </table>
        </div>

    </div>
</template>

<script>
    import {mapGetters} from 'vuex'

    export default {
        name: 'Order',
        computed: {
            ...mapGetters({
                state: 'getState',

            }),
            showCheckout: function () {
                if (this.state.registrantData.regType) {
                    return true
                }
            },

          showPromo: function () {
            if (this.state.registrantData.promoCode !== '') {
              return true
            }
          }
        },
    }
</script>

<style scoped>
    .component-fade-enter-active, .component-fade-leave-active {
        transition: opacity .3s ease;
    }

    .component-fade-enter, .component-fade-leave-to
        /* .component-fade-leave-active below version 2.1.8 */
    {
        opacity: 0;
    }
</style>
